import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const defaultState = fromJS({
    msg: 'UserInfo',
    isLoginError:false
})



export default (state = defaultState, action) => {

    switch (action.type) {
        case actionTypes.SET_USER_INFO_DATA:
            return state.set("userInfo",action.data);
        case actionTypes.SET_USER_INFO_MSG_DATA:
            console.log("action.data",action)
            if(action.data ==='效验登录用户信息失败' || action.data === '用户已在其它位置登陆！'|| action.data === '获取用户信息失败'){
                return state.set("isLoginError",true);
            }else{
                return state.set("isLoginError",false);
            }
        case actionTypes.SET_HISTORY_DATA:
            return state.set("history",action.data);


        default:
            return state;
    }
}
